import { render, staticRenderFns } from "./IneSplineChart.vue?vue&type=template&id=04fe0ace&"
import script from "./IneSplineChart.vue?vue&type=script&lang=js&"
export * from "./IneSplineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports